import React from "react";
import { scroller } from "react-scroll";
import Resume from "../../../src/WilliamHoare-Resume2024.pdf";
import "./Home.scss";
import profilephoto from "../../assets/Images/ improvedprofileB&W.png";

function Home({ nightMode }) {
  const imageSource = profilephoto;
  const scrollToWork = () => {
    scroller.scrollTo("projects", {
      smooth: true,
      offset: -80,
      duration: 500,
    });
  };

  return (
    <section className={`home ${nightMode ? "home--night" : ""}`} id="home">
      <div className="home-video" aria-hidden="true">
        <iframe
          src="https://www.youtube.com/embed/T8BD7NZF_ow?autoplay=1&mute=1&controls=0&loop=1&playlist=T8BD7NZF_ow&modestbranding=1&playsinline=1"
          title="Night Mode background video"
          allow="autoplay; encrypted-media; picture-in-picture"
          tabIndex="-1"
        ></iframe>
      </div>
      <div className="home-video__overlay" aria-hidden="true"></div>
      <div className="banner-profilephoto">
        <img src={imageSource} alt="profilephoto" />
      </div>
      <div className="profile_container">
        <h1
          className="profile-header"
          style={{ fontFamily: "'Druk Wide Bold', sans-serif" }}
        >
          Will Hoare
        </h1>
        <h2 className="profile-subheader">E-commerce Front-End Developer</h2>
        <div className="availability-badge" aria-label="Open to projects">
          <span className="availability-badge__dot" aria-hidden="true"></span>
          <span>Open to projects</span>
        </div>

        <div className="profile-button__container">
          <button className="key-button profile-button" type="button" onClick={scrollToWork}>
            View Work
          </button>
          <a
            href="https://github.com/willhoare"
            target="_blank"
            rel="noreferrer"
            className="key-button profile-button"
          >
            GitHub
          </a>
          <a
            href={Resume}
            target="_blank"
            rel="noreferrer"
            className="key-button profile-button"
          >
            Resume
          </a>
        </div>
      </div>
    </section>
  );
}

export default Home;
